import React from "react";

import { AuthProvider } from "./ProtectedRoute/AppContext";
import MainRouting from "./Router/MainRouting";
import "./App.css";
function App() {
  return (
    <AuthProvider>
      <MainRouting/>
    </AuthProvider>
  );
}

export default App;
